import React, { useState } from "react";
import logo from "../assets/logo.png";
import { CiUser } from "react-icons/ci";
import { HiMenu, HiX } from "react-icons/hi";
import product from "../assets/product1.png";
import product1 from "../assets/product2.png";
import product2 from "../assets/product3.png";
import product3 from "../assets/product4.png";
import product4 from "../assets/product5.png";
import product5 from "../assets/product6.png";
import product6 from "../assets/product7.png";
import product7 from "../assets/product8.png";
import face from "../assets/face.png";
import twit from "../assets/video.png";
import insta from "../assets/insta.png";
import icon from "../assets/icon.png";
import icon1 from "../assets/icon1.png";
import icon2 from "../assets/icon2.png";
import icon3 from "../assets/icon3.png";
import { Link } from "react-router-dom";
import ProductInfo from "./ProductInfo";
import ProductImageGallery from "./ProductImageGallery";

function Product1() {
    return (
        <>
            <Header />
            <ProductDetail />
            <ExtraSection />
            <ProductDetail1 />
            <ProductDetail2 />
            <ProductDetail3 />
            <FAQSection />
            <Footer />
        </>
    );
}

function Header() {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    return (
        <header className="bg-white shadow-md">
            <div className="flex items-center justify-between px-4 py-4 lg:mx-20">
                {/* Logo Section */}
                <div className="flex items-center">
                    <img src={logo} alt="Bestie" className="h-16" />
                </div>

                {/* Desktop Menu Section */}
                <nav className="hidden space-x-8 font-sans font-semibold text-1xl lg:flex">
                    <a href="/" className="text-gray-700 hover:text-gray-900">
                        HOME
                    </a>
                    <a
                        href="/products"
                        className="text-gray-700 hover:text-gray-900"
                    >
                        PRODUCTS
                    </a>
                    <a
                        href="/blog"
                        className="text-gray-700 hover:text-gray-900"
                    >
                        BLOG
                    </a>
                    <a
                        href="/contact"
                        className="text-gray-700 hover:text-gray-900"
                    >
                        CONTACT
                    </a>
                </nav>

                {/* Search Bar and Admin Section */}
                <div className="flex items-center space-x-6">
                    {/* Search Bar */}
                    <div className="relative">
                        <input
                            type="text"
                            placeholder="Search"
                            className="px-4 py-2 text-sm border border-gray-300 rounded-full outline-none max-sm:hidden max-md:hidden focus:ring-2 focus:ring-gray-500"
                        />
                        <button className="absolute right-2 top-2">
                            <svg
                                className="w-5 h-5 text-gray-500 max-sm:hidden max-md:hidden"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2"
                                    d="M21 21l-4.35-4.35m0 0A7.5 7.5 0 1110.5 3a7.5 7.5 0 016.15 12.65z"
                                />
                            </svg>
                        </button>
                    </div>

                    {/* Admin Icon */}
                    <button>
                        <CiUser />
                    </button>

                    {/* Mobile Menu Toggle Button */}
                    <button onClick={toggleMenu} className="lg:hidden">
                        {/* Switch between menu icon and close icon */}
                        {isMenuOpen ? (
                            <HiX className="w-6 h-6 text-gray-700" /> // Close icon when menu is open
                        ) : (
                            <HiMenu className="w-6 h-6 text-gray-700" /> // Menu icon when menu is closed
                        )}
                    </button>
                </div>
            </div>

            {/* Mobile Menu */}
            {isMenuOpen && (
                <div className="absolute top-0 left-0 z-20 w-2/3 h-full p-6 bg-white shadow-lg lg:hidden">
                    <button
                        onClick={toggleMenu}
                        className="mb-8 text-gray-700 hover:text-gray-900"
                    >
                        <HiX className="w-8 h-8" />{" "}
                        {/* Close icon in the mobile menu */}
                    </button>
                    <nav className="flex flex-col space-y-4 font-sans font-semibold">
                        <a
                            href="/"
                            className="text-gray-700 hover:text-gray-900"
                        >
                            HOME
                        </a>
                        <a
                            href="/products"
                            className="text-gray-700 hover:text-gray-900"
                        >
                            PRODUCTS
                        </a>
                        <a
                            href="/blog"
                            className="text-gray-700 hover:text-gray-900"
                        >
                            BLOG
                        </a>
                        <a
                            href="/contact"
                            className="text-gray-700 hover:text-gray-900"
                        >
                            CONTACT
                        </a>
                    </nav>
                </div>
            )}
            <div className="border"></div>
        </header>
    );
}
function ProductDetail() {
    return (
        <div className="mt-10 bg-white">
            <div className="px-4 py-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
                <div className="flex items-center space-x-2 text-sm text-gray-500">
                    <a
                        href="/"
                        className="font-sans text-lg font-medium hover:text-gray-700"
                    >
                        Home
                    </a>
                    <span className="text-gray-400">›</span>
                    <a
                        href="/products"
                        className="font-sans text-lg font-medium hover:text-black"
                    >
                        Products
                    </a>
                    <span className="text-gray-400">›</span>
                    <span className="font-sans text-lg font-medium hover:text-black">
                        Bestie - Adult Diapers
                    </span>
                </div>
                <div className="flex flex-col mt-6 lg:flex-row">
                    <div className="w-full lg:w-1/2">
                        <img
                            src={product2}
                            alt="Product Image"
                            className="lg:w-full h-[50vh] lg:h-[80vh] lg:object-cover rounded-3xl"
                        />
                    </div>
                    <div className="flex flex-col justify-center w-full mt-4 items-left lg:mt-0 lg:w-1/2 lg:pl-10">
                        <h2 className="text-3xl font-bold">
                            Bestie - Adult Diapers
                        </h2>
                        <p className="mt-4 text-left text-gray-600">
                            Bestie Adult Diapers: Comfort and Confidence for
                            Every Moment<br></br>
                            <br></br>
                            Description: Embrace comfort and confidence with
                            Bestie Adult Diapers, the perfect choice for all-day
                            wear. Engineered with your comfort in mind, our
                            diapers provide unparalleled softness and a snug
                            fit, ensuring you stay comfortable and confident
                            throughout your day.<br></br>
                            <br></br>
                            With advanced absorbent technology, Bestie Adult
                            Diapers offer superior leakage protection, allowing
                            you to move freely without worry. Whether you're at
                            work, traveling, or simply enjoying life's moments,
                            our diapers provide reliable protection, giving you
                            the confidence to live life on your terms.<br></br>
                            <br></br>
                            Designed for extended wear, Bestie Adult Diapers are
                            gentle on the skin, preventing chafing and
                            discomfort. Say goodbye to irritation and hello to a
                            new level of comfort with our premium diapers.
                            <br></br>
                            <br></br>
                            With Bestie Adult Diapers, you can embrace each
                            moment with confidence and dignity. Don't let
                            bladder leakage hold you back – experience the
                            comfort and reliability of Bestie today!
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}

function ExtraSection() {
    return (
        <div className="mt-10 bg-white">
            <div className="px-4 py-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
                <div className="flex items-center space-x-2 text-sm text-gray-500"></div>
                <div className="flex flex-col mt-6 lg:flex-row">
                    <div className="flex flex-col justify-center w-full mt-4 items-left lg:mt-0 lg:w-1/2 lg:pl-10">
                        <h2 className="text-3xl font-bold">features</h2>
                        <p className="mt-4 text-left text-gray-600">
                            • Advanced Absorbent Technology: Dual core padding
                            in the target zone ensures optimal absorption,
                            providing unparalleled leakage protection.<br></br>
                            <br></br>• Snug yet Gentle Fit: Designed for comfort
                            and discretion, our diapers offer a snug fit that
                            allows you to move with freedom and confidence
                            <br></br>
                            <br></br>• Odor Control Technology: Bestie Adult
                            Diapers feature advanced odor control technology,
                            keeping you feeling fresh and confident throughout
                            the day.<br></br>
                            <br></br>• Soft, Breathable Materials: Crafted with
                            soft, breathable materials, our diapers ensure skin
                            comfort and prevent irritation, even during extended
                            wear.<br></br>
                            <br></br>• All-Day Wear: Suitable for extended wear,
                            Bestie Adult Diapers guarantee comfort and
                            reliability in any situation, empowering you to
                            seize the day without worries.<br></br>
                            <br></br>• Universal Design: Tailored for both men
                            and women, our diapers offer universal comfort and
                            reliability, catering to diverse needs and
                            preferences.<br></br>• Variety of Sizes: Available
                            in a range of sizes, Bestie Adult Diapers are
                            designed to suit individual needs, ensuring a
                            perfect fit for everyone.<br></br>
                            <br></br>
                        </p>
                        <p className="mt-2 text-xl font-semibold text-gray-900">
                            ₹550.00
                        </p>

                        <a href="https://wa.me/message/WYDNZKOCNVM5A1">
                            <button className="mt-6 px-4 py-2 bg-[#52B3A4] text-white rounded-md hover:bg-[#459b89]">
                                {" "}
                                Shop Now
                            </button>
                        </a>
                    </div>
                    <div className="w-full lg:w-1/2">
                        <img
                            src={product6}
                            alt="Product Image"
                            className="lg:w-full h-[50vh] lg:h-[80vh] lg:object-cover rounded-3xl"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

function ProductDetail1() {
    return (
        <div className="mt-10 bg-white">
            <div className="px-4 py-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
                <div className="flex items-center space-x-2 text-sm text-gray-500"></div>
                <div className="flex flex-col mt-6 lg:flex-row">
                    <div className="w-full lg:w-1/2">
                        {/* <img
              src={product2}
              alt="Product Image"
              className="w-full lg:w-[100vw] h-[50vh] lg:h-[80vh] lg:object-cover rounded-3xl"
            /> */}
                    </div>
                    <div className="flex flex-col justify-center w-full mt-4 items-left lg:mt-0 lg:w-1/2 lg:pl-10">
                        {/* <h2 className="text-3xl font-bold">Bestie - Adult Diapers</h2>
            <p className="mt-4 text-left text-gray-600">Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
            <p className="mt-2 text-xl font-semibold text-gray-900">₹550.00</p>
          

          <a href="https://wa.me/message/WYDNZKOCNVM5A1">

            <button className="mt-6 px-4 py-2 bg-[#52B3A4] text-white rounded-md hover:bg-[#459b89]">  Shop Now</button>

          </a> */}
                    </div>
                </div>
            </div>
        </div>
    );
}

function ProductDetail2() {
    return (
        <div className="mt-10 bg-white">
            <div className="px-4 py-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
                <div className="flex items-center space-x-2 text-sm text-gray-500"></div>
                <div className="flex flex-col mt-6 lg:flex-row">
                    {/* <div className="flex flex-col justify-center w-full mt-4 items-left lg:mt-0 lg:w-1/2 lg:pl-10">
            <h2 className="text-3xl font-bold">Bestie - Adult Diapers</h2>
            <p className="mt-4 text-left text-gray-600">Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
            <p className="mt-2 text-xl font-semibold text-gray-900">₹550.00</p>
          

          <a href="https://wa.me/message/WYDNZKOCNVM5A1">

            <button className="mt-6 px-4 py-2 bg-[#52B3A4] text-white rounded-md hover:bg-[#459b89]">  Shop Now</button>

          </a> */}
                    {/* </div> */}
                    <div className="w-full lg:w-1/2">
                        {/* <img
              src={product2}
              alt="Product Image"
              className="w-full lg:w-[100vw] h-[50vh] lg:h-[80vh] lg:object-cover rounded-3xl"
            />      */}
                    </div>
                </div>
            </div>
        </div>
    );
}

function ProductDetail3() {
    return (
        <div className="mt-10 mb-10 bg-white">
            <div className="px-4 py-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
                <div className="flex items-center space-x-2 text-sm text-gray-500"></div>
                <div className="flex flex-col mt-6 lg:flex-row">
                    <div className="w-full lg:w-1/2">
                        {/* <img
              src={product4}
              alt="Product Image"
              className="w-full lg:w-[100vw] h-[50vh] lg:h-[80vh] lg:object-cover rounded-3xl"
            />  */}
                    </div>
                    <div className="flex flex-col justify-center w-full mt-4 items-left lg:mt-0 lg:w-1/2 lg:pl-10">
                        {/* <h2 className="text-3xl font-bold">Bestie - Adult Diapers</h2>
            <p className="mt-4 text-left text-gray-600">Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
            <p className="mt-2 text-xl font-semibold text-gray-900">₹550.00</p>
           */}

                        {/* <a href="https://wa.me/message/WYDNZKOCNVM5A1">

            <button className="mt-6 px-4 py-2 bg-[#52B3A4] text-white rounded-md hover:bg-[#459b89]">  Shop Now</button>

          </a> */}
                    </div>
                </div>
            </div>
        </div>
    );
}

// function RecommendedProducts() {
//   const recommendedProducts = [
//     {
//       id: 1,
//       name: "Bestie - Product 1",
//       price: "₹550.00",
//       imageSrc: product,
//       href: "/product1",
//     },
//     {
//       id: 2,
//       name: "Product 2 Microfabric Fabric",
//       price: "₹799.00",
//       imageSrc: product1,
//       href: "/product2",
//     },
//     {
//       id: 3,
//       name: "Microfabric Fabric T-Shirt",
//       price: "₹799.00",
//       imageSrc: product2,
//       href: "/product3",
//     },
//     {
//       id: 4,
//       name: "Round Neck Full Sleeve T-Shirt",
//       price: "₹599.00",
//       imageSrc: product3,
//       href: "/product4",
//     },
//   ];

//   return (
//     <div className="px-4 py-16 mx-auto max-w-7xl sm:px-6 lg:px-8">
//       <div className="grid grid-cols-1 gap-y-10 sm:grid-cols-2 lg:grid-cols-4 lg:gap-x-6 xl:gap-x-8"></div>
//       <h2 className="mb-10 font-sans text-2xl font-medium hover:text-black">Recommended Products</h2>

//       <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
//         {recommendedProducts.map((product) => (
//           <div key={product.id} className="relative overflow-hidden bg-white border border-gray-200 shadow-lg group rounded-xl">
//           <div className="w-full px-2 py-2 bg-white aspect-w-1 aspect-h-1 rounded-t-xl lg:aspect-none">
//             <img
//               src={product.imageSrc}
//               alt={product.name}
//               className="object-cover object-center w-full h-full lg:w-full lg:h-full"
//             />
//           </div>
//           <div className="p-4 space-y-2">
//             <h3 className="text-sm text-gray-700">
//               {product.name}
//             </h3>
//             <div className="flex items-center justify-between">
//               <p className="text-lg font-medium text-gray-900">{product.price}</p>
//               <Link to={product.href}>
//                 <button className="py-1 px-4 bg-[#52B3A4] text-white text-sm rounded-md hover:bg-[#52B3A4]">
//                   Shop Now
//                 </button>
//               </Link>
//             </div>
//           </div>
//         </div>
//         ))}
//       </div>
//     </div>
//   );
// }

function FAQSection() {
    const [activeIndex, setActiveIndex] = useState(null);

    const faqs = [
        {
            question: "What Is Your Return Policy?",
            answer: "You can return items within 30 days of purchase.",
        },
        {
            question: "How Long Does Shipping Take?",
            answer: "Shipping typically takes 5-7 business days.",
        },
        {
            question: "Do You Offer International Shipping?",
            answer: "Yes, we ship to select countries worldwide.",
        },
        {
            question: "Can I Change My Order After Placing It?",
            answer: "You can change your order within one hour of placing it.",
        },
    ];

    const toggleFAQ = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    return (
        <div className="w-full py-16 bg-gray-50">
            {" "}
            {/* Full section wrapper with padding */}
            <div
                className="max-w-4xl 
      px-4 mx-auto sm:px-6 lg:px-8"
            >
                {" "}
                {/* Container for equal left-right space */}
                <h2 className="font-sans text-3xl font-semibold tracking-tight text-center text-gray-900">
                    Frequently Asked Questions
                </h2>
                <br></br>
                {/* FAQ List */}
                <div className="space-y-4">
                    {faqs.map((faq, index) => (
                        <div
                            key={index}
                            className="pb-4 border-b-2 border-gray-200 cursor-pointer"
                            onClick={() => toggleFAQ(index)}
                        >
                            <div className="flex items-center justify-between">
                                <h3 className="font-sans text-lg font-semibold text-gray-700">
                                    {faq.question}
                                </h3>
                                <svg
                                    className={`w-6 h-6 transition-transform transform ${
                                        activeIndex === index
                                            ? "rotate-180"
                                            : ""
                                    }`}
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth="2"
                                        d="M19 9l-7 7-7-7"
                                    />
                                </svg>
                            </div>
                            {activeIndex === index && (
                                <p className="mt-2 text-gray-600">
                                    {faq.answer}
                                </p>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

function Footer() {
    return (
        <div className=" footer w-full py-7 bg-[#FFB4703D]">
            {/* Logo Row */}
            <div className="flex items-center justify-center">
                <img src={logo} alt="Logo" className="w-32" />
            </div>

            {/* Columns Row */}
            <div className="grid grid-cols-1 gap-4 mt-6 md:grid-cols-4">
                {/* Column 1 */}
                <div className="flex flex-col items-center">
                    <img
                        src={icon}
                        alt="Free Shipping"
                        className="flex flex-row h-12 w-15"
                    />
                    <br></br>
                    <h3 className="font-sans font-bold">Free Shipping</h3>
                    <p className="font-sans font-normal ">
                        On all orders over ₹50
                    </p>
                </div>

                {/* Column 2 */}
                <div className="flex flex-col items-center">
                    <img
                        src={icon1}
                        alt="Secure Payment"
                        className="w-12 h-12"
                    />
                    <br></br>
                    <h3 className="font-sans font-bold">Secure Payment</h3>
                    <p className="font-sans font-normal ">
                        Guaranteed safe checkout
                    </p>
                </div>

                {/* Column 3 */}
                <div className="flex flex-col items-center">
                    <img
                        src={icon2}
                        alt="Customer Support"
                        className="w-12 h-12"
                    />
                    <br></br>
                    <h3 className="font-sans font-bold">
                        24/7 Customer Support
                    </h3>
                    <p className="font-sans font-normal ">
                        We're here to help you
                    </p>
                </div>

                {/* Column 4 */}
                <div className="flex flex-col items-center">
                    <img
                        src={icon3}
                        alt="Return Policy"
                        className="w-12 h-12"
                    />
                    <br></br>
                    <h3 className="font-sans font-bold">Easy Returns</h3>
                    <p className="font-sans font-normal ">
                        Hassle-free returns within 30 days
                    </p>
                </div>
            </div>

            {/* Social Media Row */}
            <div className="mt-6 text-center">
                <h3 className="font-sans font-bold">Follow Us</h3>
                <div className="flex justify-center mt-2 space-x-4">
                    <a
                        href="https://facebook.com"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <img src={face} alt="Facebook" className="w-8 h-8" />
                    </a>
                    <a
                        href="https://twitter.com"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <img src={twit} alt="Twitter" className="w-8 h-8" />
                    </a>
                    <a
                        href="https://instagram.com"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <img src={insta} alt="Instagram" className="w-8 h-8" />
                    </a>
                </div>
            </div>

            {/* Copyright Row */}
            <div className="w-full mx-0 bg-[#52B3A4] py-4 mt-6 text-center text-white font-sans">
                <p>
                    &copy; {new Date().getFullYear()} Fab Dudes. All rights
                    reserved.
                </p>
            </div>
        </div>
    );
}

export default Product1;
